import { render, staticRenderFns } from "./Mirrored.vue?vue&type=template&id=47008d06&"
import script from "./Mirrored.vue?vue&type=script&lang=js&"
export * from "./Mirrored.vue?vue&type=script&lang=js&"
import style0 from "./Mirrored.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Mirrored.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Mirrored.vue"
export default component.exports